export const CHAT_LABEL_DICTATION_CORRECT = "正解";
